import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_TASKS_LIST](state, data) {
        state.tasksList = data;
    },
    [action.SET_TASKS_FILTER](state, filter) {
        state.taskFilter = filter;
    },
    [action.SET_MY_TASKS_FILTER](state, filter) {
        state.myTaskFilter = filter;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
};

export default mutations;
